module.exports = __webpack_public_path__ + "static/node-6217b547de02228b6bdac7bb59fe9341.png";